import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  constructor() {}

  get window(): any {
    return window;
  }

  get location(): any {
    return window.location;
  }
}
